import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = auth
  const token = localStorage.getItem("pb_token");

  useEffect(() => {
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/admin/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("pb_token");
        setUser(false);
      });
  }, [token]);

  const login = async (email, password) => {
    const res = await api.post("/admin/login", { email, password });
    localStorage.setItem("pb_token", res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = async () => {
    try {
      await api.post("/admin/logout");
    } catch (e) {
      /* ignore */
    }
    localStorage.removeItem("pb_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
